module.exports = __webpack_public_path__ + "media/images/members/trial_freelances/img_articles451_1-fbb8e32b990c95a758a6ccf2690ae2b4.png";